var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('nav-menu', _vm._g(_vm._b({
    attrs: {
      "name": "Occasions",
      "title": "Greeting cards for any occasion",
      "subtitle": "Add your own text, pictures, videos, and more",
      "action": "View all cards",
      "icon": _vm.mdiCards,
      "to": {
        name: 'catalog'
      }
    }
  }, 'nav-menu', _vm.$attrs, false), _vm.$listeners), [_c('v-row', {
    staticClass: "ma-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_vm.specialCategories.priv.length ? _c('div', {
    staticClass: "mb-3"
  }, [_c('div', {
    staticClass: "caption"
  }, [_vm._v("Private collections")]), _vm._l(_vm.specialCategories.priv, function (_ref) {
    var name = _ref[0],
        icon = _ref[1],
        iconColor = _ref[2],
        textClass = _ref[3];
    return _c('div', {
      staticClass: "mx-n2"
    }, [_c('v-btn', {
      attrs: {
        "text": "",
        "to": {
          name: 'catalog',
          query: {
            q: name
          }
        }
      }
    }, [_c('v-icon', {
      staticClass: "mr-1",
      attrs: {
        "small": "",
        "color": iconColor
      },
      domProps: {
        "innerHTML": _vm._s(icon)
      }
    }), _c('span', {
      class: textClass
    }, [_vm._v(_vm._s(_vm._f("category")(name)))])], 1)], 1);
  })], 2) : _vm._e(), _vm.specialCategories.local.length ? _c('div', {
    staticClass: "mb-3"
  }, [_c('div', {
    staticClass: "caption"
  }, [_vm._v("Special occasions")]), _vm._l(_vm.specialCategories.local, function (_ref2) {
    var name = _ref2[0],
        icon = _ref2[1],
        iconColor = _ref2[2],
        textClass = _ref2[3];
    return _c('div', {
      staticClass: "mx-n2"
    }, [_c('v-btn', {
      attrs: {
        "text": "",
        "to": {
          name: 'catalog',
          query: {
            q: name
          }
        }
      }
    }, [_c('v-icon', {
      staticClass: "mr-1",
      attrs: {
        "small": "",
        "color": iconColor
      },
      domProps: {
        "innerHTML": _vm._s(icon)
      }
    }), _c('span', {
      class: textClass,
      domProps: {
        "innerHTML": _vm._s(name)
      }
    })], 1)], 1);
  })], 2) : _vm._e(), _vm._l(_vm.DEFAULT_CATEGORIES, function (_ref3) {
    var name = _ref3[0],
        icon = _ref3[1];
    return _c('div', {
      staticClass: "mx-n2"
    }, [_c('v-btn', {
      attrs: {
        "text": "",
        "color": "primary",
        "to": {
          name: 'catalog',
          query: {
            q: name
          }
        }
      }
    }, [_c('v-icon', {
      staticClass: "mr-1",
      attrs: {
        "small": ""
      },
      domProps: {
        "innerHTML": _vm._s(icon)
      }
    }), _vm._v(_vm._s(name) + " ")], 1)], 1);
  })], 2), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('div', {
    staticClass: "caption"
  }, [_vm._v("Search for anything")]), _c('v-text-field', {
    staticClass: "mt-2 mb-1 white",
    attrs: {
      "label": "Search",
      "outlined": "",
      "dense": "",
      "rounded": "",
      "hide-details": "",
      "multiple": "",
      "single-line": "",
      "clearable": "",
      "append-icon": _vm.mdiMagnify
    },
    on: {
      "!click": function ($event) {
        $event.stopPropagation();
      },
      "click:append": _vm.search,
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments);
      }
    },
    model: {
      value: _vm.searchText,
      callback: function ($$v) {
        _vm.searchText = $$v;
      },
      expression: "searchText"
    }
  }), _vm._l(['flowers', 'funny dogs', 'animated', 'happy animals', 'summer party'], function (q) {
    return _c('div', {
      staticClass: "mx-n2"
    }, [_c('v-btn', {
      attrs: {
        "text": "",
        "color": "primary",
        "to": {
          name: 'catalog',
          query: {
            q: q.split(' ')
          }
        }
      }
    }, [_vm._v(_vm._s(q))])], 1);
  }), _c('div', {
    staticClass: "mt-6 caption"
  }, [_vm._v("Design your own cards / invitations")]), _vm._l([['Blank card', _vm.mdiPencilBoxOutline, {
    params: {
      designId: _vm.blankDesignId
    }
  }], ['Templates', _vm.iconPathCollage, {
    query: {
      q: 'Template'
    }
  }], ['Invitations', _vm.mdiCalendarMultipleCheck, {
    query: {
      q: 'Invitation'
    }
  }]], function (_ref4) {
    var name = _ref4[0],
        icon = _ref4[1],
        route = _ref4[2];
    return _c('div', {
      staticClass: "mx-n2"
    }, [_c('v-btn', {
      attrs: {
        "text": "",
        "color": "primary",
        "to": Object.assign({
          name: 'catalog'
        }, route)
      }
    }, [_c('v-icon', {
      staticClass: "mr-1",
      attrs: {
        "small": "",
        "color": "primary"
      },
      domProps: {
        "innerHTML": _vm._s(icon)
      }
    }), _vm._v(_vm._s(name) + " ")], 1)], 1);
  })], 2)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }